"use client"

import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react"
import { useCursor } from "../hooks/useCursor"

type OwnProps<T extends ElementType> = {
  as?: T
  children: ReactNode
  variant: string
  onEnter?: () => void
  onLeave?: () => void
}

type CursorTargetProps<T extends ElementType = "div"> = OwnProps<T> &
  Omit<ComponentPropsWithoutRef<T>, keyof OwnProps<T>>

export function CursorTarget<T extends ElementType = "div">({
  as,
  children,
  variant,
  onEnter,
  onLeave,
  ...rest
}: CursorTargetProps<T>) {
  const Component = (as ?? "div") as ElementType
  const cursorHandlers = useCursor({ variant, onEnter, onLeave })

  return (
    <Component {...rest} {...cursorHandlers} data-cursor-variant={variant}>
      {children}
    </Component>
  )
}
